import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { BrowserRouter } from 'react-router';

import App from './App';
import { BUSTER, MAX_AGE_MS, keepSavedQueries, persister, saveOnBackground, shouldSave } from './core/cache';
import { initConfig } from './core/config';
import { startSplash } from './core/splash';
import { initTheme } from './core/theme';
import { initI18n } from './i18n';
import './styles/mockup.css';
import './styles/base.css';

startSplash();
initTheme();
initI18n();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true } },
});
// The saved cache (D-87): the last loaded day opens at once, then refreshes.
keepSavedQueries(queryClient);
saveOnBackground();
const persistOptions = { persister, maxAge: MAX_AGE_MS, buster: BUSTER, dehydrateOptions: { shouldDehydrateQuery: shouldSave } };

initConfig().then(() => {
  const root = document.getElementById('root');
  if (!root) return;
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistQueryClientProvider>
    </React.StrictMode>,
  );
});

// Offline asset cache for the installed PWA (salon-plan §14). Production only:
// in development it would serve stale bundles.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => console.warn('Service worker failed:', err));
  });
}
